import { render, staticRenderFns } from "./AIModelList.vue?vue&type=template&id=4b98098b&"
import script from "./ai-model-list.js?vue&type=script&lang=js&"
export * from "./ai-model-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports